<template>
  <div class="orders-and-invoices-container pt-5">
    <div>
      <MobileNavButtons
        v-if="$vuetify.display.mobile"
        :Statuses="statusesWithParentPath"
      />
    </div>
    <!-- <Filters
      @update:date="updateDate"
      @update:searchInput="updateSearchInput"
    /> -->
    <!-- <div
      v-if="
        (isOrders || isReturnCustDocs) &&
        (awaitingOrdersCount > 0 || awaitingReturnCustDocs > 0)
      "
      class="orders-info"
    >
      יש לך
      <strong>{{
        isOrders ? awaitingOrdersCount : awaitingReturnCustDocs
      }}</strong>
      {{ isOrders ? "הזמנות" : "תעודות סחורה מלקוח" }} ממתינות לעיבוד
    </div> -->
    <div v-if="docsList.length > 0" class="docs-container">
      <HeadLines />
      <div class="docs-lines-container">
        <div
          v-for="doc in docsList.filter((doc, index) => index < 50)"
          :key="isOrders ? doc.ordname : isInvs ? doc.ivnum : doc.docno"
          @click="
            navigateToDoc(
              isOrders ? doc.ordname : isInvs ? doc.ivnum : doc.docno
            )
          "
        >
          <component
            :doc="doc"
            :is="
              isOrders ? 'OrdLine' : isInvs ? 'InvLine' : 'ReturnCustDocLine'
            "
          >
          </component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MobileNavButtons from "../helpers/MobileNavButtons.vue";
import { mapActions, mapGetters } from "vuex";
import OrdLine from "../helpers/OrdLine.vue";
import InvLine from "../helpers/InvLine.vue";
import ReturnCustDocLine from "../helpers/ReturnCustDocLine.vue";
import HeadLines from "../helpers/HeadLines.vue";
import Filters from "../helpers/ProductsFilters.vue";
import Alert from "../helpers/Alert.vue";
import moment from "moment";

export default {
  components: {
    MobileNavButtons,
    OrdLine,
    InvLine,
    HeadLines,
    Filters,
    Alert,
    ReturnCustDocLine,
  },
  async mounted() {
    // await this.setListByPath();
    // this.filterOrdersByStatus();
    // if (this.docsList?.length) {
    //   this.docsList = this.docsList.sort(function (a, b) {
    //     return (
    //       new Date(b?.senddate ?? b.ivdate) - new Date(a?.senddate ?? a.ivdate)
    //     );
    //   });

    //   this.docsList = this.docsList.sort(function (a, b) {
    //     // Extract the prefix and number parts using regex
    //     const [, prefixA = "", numA = "0"] =
    //       (a?.ordname || "").match(/^(SO|IN)(\d+)/) || [];
    //     const [, prefixB = "", numB = "0"] =
    //       (b?.ordname || "").match(/^(SO|IN)(\d+)/) || [];

    //     // If prefixes are different, sort by prefix first
    //     if (prefixA !== prefixB) {
    //       return prefixB.localeCompare(prefixA);
    //     }

    //     // If prefixes are the same, sort by number
    //     return parseInt(numB) - parseInt(numA);
    //   });
    // }
  },
  data() {
    return {
      docsList: [],
      searchInput: "",
      date: "",
      awaitingOrdersCount: 0,
      awaitingReturnCustDocs: 0,
    };
  },
  watch: {
    date() {
      if (this.date) {
        const formattedDate = moment(this.date)
          .startOf("day")
          .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"); // Using the exact ISO format you need

        this.setRouteQuery({ date: formattedDate });
      } else {
        this.removeSpecificQuery("date");
        this.date = "";
      }
    },
    searchInput() {
      if (this.searchInput) {
        this.setRouteQuery({ SKUOrOrd: this.searchInput });
      } else {
        this.removeSpecificQuery("SKUOrOrd");
      }
    },
    "$route.name"() {
      this.setListByPath();
    },
    "$route.params.status"() {
      this.whoComesToTheParty();
    },
    "$route.query.SKUOrOrd"() {
      this.whoComesToTheParty();
    },
    "$route.query.date"() {
      this.whoComesToTheParty();
    },
  },
  methods: {
    async setListByPath() {
      // console.log("this.$route.name", this.$route.name);
      if (this.$route.name === "orders") {
        this.docsList = this.Orders;
        // check for awating orders
        try {
          this.awaitingOrdersCount = await this.$store.dispatch(
            "Orders/getAwatingOrders"
          );
        } catch {
          this.awaitingOrdersCount = 0;
        }
      } else if (this.$route.name === "invocies") {
        this.docsList = this.Invoices;
      } else {
        this.docsList = this.ReturnCustDocs;
        // check for awating ReturnCustDocs
        try {
          this.awaitingReturnCustDocs = await this.$store.dispatch(
            "Invoices/getAwaitingReturnCustDocs"
          );
        } catch {
          this.awaitingReturnCustDocs = 0;
        }
      }
    },
    navigateToDoc(id) {
      const route =
        this.$route.name === "orders"
          ? "/Order/"
          : this.isInvs
          ? "/Invoice/"
          : "/ReturnDocLine/";
      this.$router.push(route + id);
    },
    updateDate(date) {
      this.date = date;
      this.whoComesToTheParty();
    },
    updateSearchInput(input) {
      this.searchInput = input;
      this.whoComesToTheParty();
    },
    whoComesToTheParty() {
      if (this.isOrders) {
        this.docsList = this.filterOrderList();
      } else if (this.isInvs) {
        this.docsList = this.filterInvoiceList();
      } else {
        this.docsList = this.filterReturnCustDocList();
      }
      console.log("whoComesToTheParty");
      console.log(this.docsList);
    },
    filterReturnCustDocList() {
      return this.ReturnCustDocs.filter((returnCustDoc) => {
        // Check status parameter
        if (
          this.$route.params.status &&
          returnCustDoc.Status.statdes != this.$route.params.status
        ) {
          return false;
        }

        // Check date parameter
        if (
          this.$route.query.date &&
          returnCustDoc.curdate.split("T")[0] !=
            this.$route.query.date.split("T")[0]
        ) {
          return false;
        }

        // Check SKUOrOrd query parameter
        if (this.$route.query.SKUOrOrd) {
          let partNotExists = returnCustDoc.ReturnCustDocLines.every((line) => {
            // Check both part.partname and the original partname comparison
            return (
              !String(line.part?.partname).includes(
                String(this.$route.query.SKUOrOrd)
              ) &&
              !String(line.partname).includes(
                String(this.$route.query.SKUOrOrd)
              )
            );
          });

          if (
            partNotExists &&
            !String(returnCustDoc.docno).includes(
              String(this.$route.query.SKUOrOrd)
            )
          ) {
            return false;
          }
        }

        return true;
      });
    },

    filterInvoiceList() {
      return this.Invoices.filter((invoice) => {
        // Check status parameter
        if (
          this.$route.params.status &&
          invoice.Status.statdes != this.$route.params.status
        ) {
          return false;
        }

        // Check date parameter
        if (
          this.$route.query.date &&
          invoice.ivdate.split("T")[0] != this.$route.query.date.split("T")[0]
        ) {
          return false;
        }

        // Check SKUOrOrd query parameter
        if (this.$route.query.SKUOrOrd) {
          let partNotExists = invoice.InvoiceLines.every((line) => {
            // Check both part.partname and the original part string comparison
            return (
              !String(line.partname).includes(
                String(this.$route.query.SKUOrOrd)
              ) &&
              !String(line.part).includes(String(this.$route.query.SKUOrOrd))
            );
          });

          if (
            partNotExists &&
            !String(invoice.ivnum).includes(String(this.$route.query.SKUOrOrd))
          ) {
            return false;
          }
        }

        return true;
      });
    },
    filterOrderList() {
      return this.Orders.filter((order) => {
        // Check status parameter
        if (
          this.$route.params.status &&
          order.Status.statdes != this.$route.params.status
        ) {
          return false;
        }

        // Check date parameter
        if (
          this.$route.query.date &&
          order.senddate.split("T")[0] != this.$route.query.date.split("T")[0]
        ) {
          return false;
        }

        // Check SKUOrOrd query parameter
        if (this.$route.query.SKUOrOrd) {
          console.log(order);

          let partNotExists = order.OrderLines.every((line) => {
            // Check both part.partname and the original part string comparison
            return (
              !String(line.partname).includes(
                String(this.$route.query.SKUOrOrd)
              ) &&
              !String(line.part).includes(String(this.$route.query.SKUOrOrd))
            );
          });

          if (
            partNotExists &&
            !String(order.ordname).includes(String(this.$route.query.SKUOrOrd))
          ) {
            return false;
          }
        }

        return true;
      });
    },
    removeSpecificQuery(key) {
      let query = { ...this.$route.query };
      delete query[key];
      this.$router.push({ path: this.$route.path, query: query });
    },
    async setRouteQuery(query) {
      query = { ...this.$route.query, ...query };
      await this.$router.push({ path: this.$route.path, query: query });
    },
    openOrder(id) {
      this.$router.push("/SingleOrder/" + id);
    },
    filterOrdersByStatus() {
      let status = parseInt(this.$route.params.status);
      if (status && !isNaN(status)) {
        this.docsList = this.docsList.filter((order) => {
          return order.Status.statdes == status;
        });
      }
    },
    ...mapActions({
      updateOrderLine: "Orders/updateOrderLine",
    }),
  },
  computed: {
    isLoginModelOpen() {
      return this.$route.name === "loginPage";
    },
    isOrders() {
      return this.$route.name === "orders";
    },
    isInvs() {
      return this.$route.name === "invocies";
    },
    isReturnCustDocs() {
      return this.$route.name === "returncustdocs";
    },
    statusesWithParentPath() {
      if (this.$route.name === "orders") return this.ordersStatuses;
      return this.invoicesStatuses;
    },
    getCurrentStatus() {
      if (this.$route.params.status === undefined) return "";
      return "/" + this.$route.params.status;
    },
    columnsWidth() {
      return this.$route.name === "orders" ? "19%" : "24%";
    },
    columnLength() {
      return this.$route.name === "orders" ? 5 : 4;
    },
    ...mapGetters({
      Orders: "Orders/getOrders",
      Invoices: "Invoices/getInvoices",
      ReturnCustDocs: "Invoices/getReturnCustDocs",
      AddressList: "Orders/getOrderAddresses",
      getUserPhone: "AuthModule/getUserPhone",
      cart: "Orders/getCart",
      getIsMobile: "isMobile",
      ordersStatuses: "Orders/getOrderStatuses",
      invoicesStatuses: "Invoices/getInvoicesStatuses",
    }),
  },
};
</script>

<style scoped lang="scss">
.orders-info {
  // background: $primaryBackgroundColor;
  border: 1px solid #fb8c00;
  color: #fb8c00 !important;
  padding: 5px 10px;
  border-radius: 10px;
  margin-right: 15px;
  margin-bottom: 20px;
  font-size: 18px;
  width: fit-content;
}

.orders-and-invoices-container {
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
}

@media (max-width: 601px) {
  .docs-container {
    width: 100vw;
    overflow-x: auto;
  }

  .docs-lines-container {
    width: fit-content;
    padding: 0px 20px;
    padding-left: 30px;
  }
}
</style>
